import React, { useMemo, useState } from 'react';

import { useMediaQuery } from 'react-responsive';
import Header from './Header';
import Content from './Content';

import { TypeReport } from './types';

import useConsumptionHistory from './hooks/useConsumptionHistory';

import { ModalCustom, Container, MessageWrap, MessageLoading } from './styles';
import ConsumptionHistoryDetails from './ConsumptionHistoryDetails';

const ConsumptionHistory: React.FC = () => {
  const [typeReport, setTypeReport] = useState<TypeReport>('graph');
  const [showModal, setShowModal] = useState<boolean>(false);
  const [dataValue, setDataValue] = useState<number>(1);

  const {
    consumptionDetailsData,
    consumptionDataFormated,
    average,
    maxValue,
    isLoading,
    isLoadingExcel,
    exportExcel,
  } = useConsumptionHistory(dataValue, typeReport);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const disabledExport = useMemo(() => {
    return (
      isLoading ||
      isLoadingExcel ||
      consumptionDataFormated.length === 0 ||
      typeReport === 'list'
    );
  }, [isLoading, isLoadingExcel, consumptionDataFormated, typeReport]);

  const Component = (
    <Container>
      <Header
        disableExport={disabledExport}
        isLoadingExcel={isLoadingExcel}
        exportExcel={exportExcel}
        typeReport={typeReport}
        setTypeReport={setTypeReport}
        dataValue={dataValue}
        setDataValue={setDataValue}
        showModal={showModal}
        setShowModal={setShowModal}
      />
      {typeReport === 'graph' ? (
        <>
          {!isLoading && consumptionDataFormated.length > 0 && (
            <Content
              dataValue={dataValue}
              data={consumptionDataFormated}
              average={average}
              maxValue={maxValue}
            />
          )}
          {isLoading && (
            <MessageWrap>
              <MessageLoading>Carregando, aguarde...</MessageLoading>
            </MessageWrap>
          )}
          {!isLoading && consumptionDataFormated.length === 0 && (
            <MessageWrap>
              <MessageLoading>
                Nenhuma informação a ser exibida.
              </MessageLoading>
            </MessageWrap>
          )}
        </>
      ) : (
        <>
          {!isLoading && consumptionDetailsData.length > 0 && (
            <ConsumptionHistoryDetails data={consumptionDetailsData} />
          )}
          {isLoading && (
            <MessageWrap>
              <MessageLoading>Carregando, aguarde...</MessageLoading>
            </MessageWrap>
          )}
          {!isLoading && consumptionDetailsData.length === 0 && (
            <MessageWrap>
              <MessageLoading>
                Nenhuma informação a ser exibida.
              </MessageLoading>
            </MessageWrap>
          )}
        </>
      )}
    </Container>
  );

  return (
    <>
      {Component}
      <ModalCustom
        isMobile={isMobile}
        typeReport={typeReport}
        show={showModal}
        fullscreen
        animation={false}
      >
        {Component}
      </ModalCustom>
    </>
  );
};

export default ConsumptionHistory;
